<template>
<div class="chartShow">
    <div class="chartlist" v-if="show">
        <div class="leftchart" :style="{ height: '530px' }">
            <v-chart :option="options"></v-chart>
        </div>
        <div class="rightlist">
            <el-table
                :data="tableData"
                border
                size="medium"
            >
                <el-table-column
                    prop="xh"
                    :label="$t('序号')"
                    width="80"
                >
                </el-table-column>
                <template v-for="(item,index) in tableColumns">
                    <el-table-column
                        :prop="item.k"
                        :label="item.v"
                        :width="item.w"
                        :key="index"
                    >
                    </el-table-column>
                </template>
            </el-table>
        </div>
    </div>
    <div class="pageshow">
        <el-pagination
            background
            layout="slot, prev, pager, next"
            :total="count"
            :current-page="page"
            :page-size="pagesize"
            @current-change="changepage"
        >
            <span v-if="baseapp==0" class="baseapp"> {{$t('cm5vw31u')}} </span>
            <span v-else class="el-pagination__total"> {{$t('共')}} {{count}} {{$t('条')}} </span>
        </el-pagination>
    </div>
</div>
</template>
<script>
export default {
    name: "my-chart-list-sankey",
    props: {
        datas: {
            type: Array,
            default:()=>[]
        },
        infoname: {
            type: String
        },
        columns: {
            type: Array,
            default: ()=>[]
        },
        baseapp: {
            type: Number,
            required: false
        }
    },
    data(){
        return {
            page: 1,
            pagesize: 10,
            show: true,
        }
    },
    computed:{
        options(){
            // 对可视化数据进行处理
            let datas = [];
            let links = [];
            if (this.tableData.length>0) {
                let infoname = this.infoname;
                let infodata = this.tableData;
                infodata.forEach(v => {
                    let title = v.title;
                    // if条件加空格避免与父节点重名
                    if(infoname==title){
                        title = title+" "
                    }
                    datas.push({name: title});
                    links.push({source: infoname, target: title, value: v.hz_count});
                });
                datas.push({name: infoname})
            }
            return {
                title: {
                    subtext: '',
                    left: 'center'
                },
                color:['#91cc75', '#fac858', '#ee6666', '#73c0de', '#3ba272', '#fc8452', '#9a60b4', '#ea7ccc'],
                backgroundColor: '#FFFFFF',
                series: {
                    type: 'sankey',
                    top: 10,
                    bottom: 40,
                    right: 220,
                    nodeGap: 10,
                    layout: 'none',
                    emphasis: {
                        focus: 'adjacency'
                    },
                    lineStyle: {
                        color: 'gradient',
                        curveness: 0.5
                    },
                    data: datas,
                    links:  links,
                },
                tooltip: {
                    trigger: 'item'
                }
            }
        },
        tableColumns(){
            return this.columns;
        },
        tableData(){
            let res = [];
            this.datas.map((val,index)=>{
                val['title'] = val?.title;
                val['xh'] = index+1;
                return val;
            })
            let page = this.page;
            let pagesize = this.pagesize;
            let offset = (page-1)*pagesize;
            res = this.datas.slice(offset, offset+pagesize);
            return res;
        },
        chartH(){
            let res = this.datas.length*25+'px';
            return res;
        },
        // 分页相关
        count(){
            return this.datas.length;
        },
    },
    methods: {
        changepage(page){
            let self = this;
                self.show = false;
            this.page = page;
            this.$nextTick(()=>{
                self.show = true;
            })
        }
    }
}
</script>
<style lang="less">
// .el-table__body{
//     .el-table__row:hover span.ms-hover{
//         color: red;
//     }
// }

.chartShow{
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    flex-wrap: nowrap;
    .chartlist{
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }
    .leftchart{
        width: 60%;
        max-height: 530px;
    }
    .rightlist{
        width:39%;
    }
    .baseapp{
        margin-right: 10px;
        font-weight: normal;
        color: #b34d2f;
    }
}
</style>